import { render, staticRenderFns } from "./RiskCheckAllSafetyLogCreate.vue?vue&type=template&id=5901fa5b&scoped=true&"
import script from "./RiskCheckAllSafetyLogCreate.vue?vue&type=script&lang=js&"
export * from "./RiskCheckAllSafetyLogCreate.vue?vue&type=script&lang=js&"
import style0 from "./RiskCheckAllSafetyLogCreate.vue?vue&type=style&index=0&id=5901fa5b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5901fa5b",
  null
  
)

export default component.exports